export type NotifTarget = { module: string; path: string }

export function notifTarget(
  objectType: string | null | undefined,
  objectId: string | null | undefined,
  isBuyer: boolean,
): NotifTarget | null {
  const t = (objectType ?? "").toUpperCase()
  const id = objectId || null
  if (!t) return null

  if (t === "ORDER" || t.startsWith("ORDER_")) {
    return {
      module: "order",
      path: isBuyer
        ? id ? `/buyer-app/orders/${id}` : "/buyer-sales"
        : id ? `/supplier-purchase/detail/${id}` : "/supplier-purchase",
    }
  }
  // Delivery routes, delivery notes and pull sheets are supplier warehouse screens:
  // a buyer has no such route, so a buyer row gets no target (B49).
  if (isBuyer && (t === "DELIVERY_ROUTE" || t === "ROUTE_COMPLETED" || t === "ROUTE_LOADING_ASSIGNED" || t === "DELIVERY_NOTE" || t === "DELIVERY_PROGRESS_NOTE" || t === "ASSIGN_DELIVERY" || t === "GOODS_PREPARED" || t === "CUSTODY_HANDOVER_TO_DRIVER" || t.startsWith("PULL_SHEET"))) {
    return null
  }
  if (t === "DELIVERY_ROUTE" || t === "ROUTE_COMPLETED" || t === "ROUTE_LOADING_ASSIGNED") {
    return { module: "order", path: id ? `/delivery-routes/${id}` : "/delivery-routes" }
  }
  if (
    t === "DELIVERY_NOTE" ||
    t === "DELIVERY_PROGRESS_NOTE" ||
    t === "ASSIGN_DELIVERY" ||
    t === "GOODS_PREPARED" ||
    t === "CUSTODY_HANDOVER_TO_DRIVER" ||
    t.startsWith("PULL_SHEET")
  ) {
    return { module: "order", path: "/supplier-delivery" }
  }
  if (t.startsWith("RETURN")) {
    return {
      module: "order",
      path: isBuyer
        ? id ? `/buyer-app/my-returns/${id}` : "/buyer-app/my-returns"
        : id ? `/returns/${id}` : "/returns",
    }
  }
  if (t.startsWith("INVOICE")) {
    return { module: "invoice", path: isBuyer ? "/buyer-invoice" : "/sales-invoice" }
  }
  if (t.startsWith("INVITATION")) {
    return { module: "network", path: "/came" }
  }
  if (t.startsWith("INVENTORY")) {
    return { module: "item", path: "/resource" }
  }
  if (t.startsWith("CONTRACT")) {
    return { module: "contract", path: "/contracts" }
  }
  if (t.includes("QUOTATION") || t.startsWith("PRICE")) {
    return { module: "price", path: id ? `/received-quotation/${id}` : "/received-quotation" }
  }
  if (t.startsWith("PAYMENT") || t === "TRANSACTION") {
    return { module: "payment", path: "/history" }
  }
  if (t.startsWith("CONSIGNMENT")) {
    return { module: "consignment", path: "/consignment/retailers" }
  }
  return null
}
